module.exports = __webpack_public_path__ + "static/media/headerLogo.72741289.png";